import { useLocalStorage } from 'usehooks-ts';

export default function usePromptDismissal(userId: number) {
  const [dismissedUsers, setDismissedUsers] = useLocalStorage<Record<string, boolean>>(
    'data-model-v2-upgrade:prompt-dismissals',
    {},
  );

  return {
    dismissed: dismissedUsers[userId] === true,
    dismiss: () => setDismissedUsers((previous) => ({ ...previous, [userId]: true })),
  };
}
